export type Position = (typeof Position)[keyof typeof Position];

export const Position = {
  POINT_GUARD: 'POINT_GUARD',
  POINT_GUARD_SHOOTING_GUARD: 'POINT_GUARD_SHOOTING_GUARD',
  SHOOTING_GUARD: 'SHOOTING_GUARD',
  SHOOTING_GUARD_SMALL_FORWARD: 'SHOOTING_GUARD_SMALL_FORWARD',
  SMALL_FORWARD: 'SMALL_FORWARD',
  SMALL_FORWARD_POWER_FORWARD: 'SMALL_FORWARD_POWER_FORWARD',
  POWER_FORWARD: 'POWER_FORWARD',
  POWER_FORWARD_CENTER: 'POWER_FORWARD_CENTER',
  CENTER: 'CENTER',
  NO_POSITION: 'NO_POSITION',
} as const;
